import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const TournamentLogoCellComponent = ({ value: { logo, tournamentName } }) => (
  <div css={styles.container}>
    {logo ? (
      <InWinImage source={logo} alt={tournamentName} css={styles.logo} />
    ) : (
      <Text size={16} bold>
        {tournamentName}
      </Text>
    )}
  </div>
)

TournamentLogoCellComponent.propTypes = {
  value: PropTypes.shape(),
}

export default TournamentLogoCellComponent
